import { fetchQuery } from 'react-relay';
import environment from 'shared/relay/environment';
import callMutation from 'shared/relay/mutations/call-mutation';
import privatePackageTrackerQuery from 'shared/relay/queries/privatePackageTracker.query';
import authMutation from './auth.mutation';

function checkAuthentication(packageId) {
  return new Promise((resolve, reject) =>
    fetchQuery(environment, privatePackageTrackerQuery, {
      packageId
    })
      .then(queryProps => resolve(queryProps))
      .catch(error => reject(error))
  );
}

function authenticate(packageId, nif, onSuccess, onFailure) {
  const variables = {
    input: {
      packageId,
      nif,
      clientMutationId: ''
    }
  };

  const callbacks = {
    onSuccess: response => onSuccess(response),
    onFailure: () => onFailure()
  };

  return callMutation(authMutation, variables, callbacks);
}

function authService() {
  return {
    authenticate,
    checkAuthentication
  };
}

export default authService();
